/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Empty_State_TitleInputs */

const en_manual_qc_empty_state_title = /** @type {(inputs: Manual_Qc_Empty_State_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No issues found`)
};

const fr_manual_qc_empty_state_title = /** @type {(inputs: Manual_Qc_Empty_State_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun incident trouve`)
};

const de_manual_qc_empty_state_title = /** @type {(inputs: Manual_Qc_Empty_State_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Es wurden keine Probleme gefunden`)
};

const it_manual_qc_empty_state_title = /** @type {(inputs: Manual_Qc_Empty_State_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun problema trovato`)
};

const ru_manual_qc_empty_state_title = /** @type {(inputs: Manual_Qc_Empty_State_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Проблем не обнаружено`)
};

const es_manual_qc_empty_state_title = /** @type {(inputs: Manual_Qc_Empty_State_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron problemas`)
};

const zh_cn2_manual_qc_empty_state_title = /** @type {(inputs: Manual_Qc_Empty_State_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未发现问题`)
};

const ja_manual_qc_empty_state_title = /** @type {(inputs: Manual_Qc_Empty_State_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`問題は見つかりませんでした`)
};

const hi_manual_qc_empty_state_title = /** @type {(inputs: Manual_Qc_Empty_State_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई समस्या नहीं पाई गई`)
};

const pt_pt2_manual_qc_empty_state_title = /** @type {(inputs: Manual_Qc_Empty_State_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum problema encontrado`)
};

/**
* | output |
* | --- |
* | "No issues found" |
*
* @param {Manual_Qc_Empty_State_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_empty_state_title = /** @type {((inputs?: Manual_Qc_Empty_State_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Empty_State_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_empty_state_title(inputs)
	if (locale === "de") return de_manual_qc_empty_state_title(inputs)
	if (locale === "it") return it_manual_qc_empty_state_title(inputs)
	if (locale === "ru") return ru_manual_qc_empty_state_title(inputs)
	if (locale === "es") return es_manual_qc_empty_state_title(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_empty_state_title(inputs)
	if (locale === "ja") return ja_manual_qc_empty_state_title(inputs)
	if (locale === "hi") return hi_manual_qc_empty_state_title(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_empty_state_title(inputs)
	return en_manual_qc_empty_state_title(inputs)
});